/**
 * 分销中心页埋点
 */
export const PAGE_CID = 'c_waimai_2o6ecnjo'

// 导航栏埋点值
export const NAVIGATION_HEADER_BID_MV = {
  LOCATION: 'b_waimai_9asogyni_mv', // 定位入口
  SEARCH_INPUT: 'b_waimai_pg9aptbn_mv', // 搜索输入框
  SEARCH_WORD: 'b_waimai_awgpptm9_mv', // 搜索词
}

// 导航栏点击埋点值
export const NAVIGATION_HEADER_BID_MC = {
  LOCATION: 'b_waimai_9asogyni_mc', // 定位入口
  SEARCH_BUTTON: 'b_waimai_q3pd0q1y_mc', // 搜索按钮
}

// 资源位埋点值
export const RESOURCE_SLOT_BID_MV = {
  CARD: 'b_waimai_k0difdgd_mv', // 瓷片
  FLOAT_BUTTON: 'b_waimai_slvbejwx_mv', // 浮层按钮
  CARD_JUMP_FAIL: 'b_waimai_gds0agm8_mv', // 瓷片跳转失败埋点
}

// 资源位埋点值
export const RESOURCE_SLOT_BID_MC = {
  CARD: 'b_waimai_k0difdgd_mc', // 瓷片
  FLOAT_BUTTON: 'b_waimai_slvbejwx_mc', // 浮层按钮
  FLOAT_BUTTON_JUMP_SUCCESS: 'b_waimai_1mkvx66c_mc', // 浮层按钮跳转成功埋点
}

export const TABBAR_BID_MV = {
  TAB: 'b_waimai_bg4ghiko_mv', // 标签栏Tab
  QUICK_SELECTION: 'b_waimai_8ffkwlal_mv', // 快筛
}

export const TABBAR_BID_MC = {
  TAB: 'b_waimai_bg4ghiko_mc', // 标签栏Tab
  QUICK_SELECTION: 'b_waimai_8ffkwlal_mc', // 快筛
}

export const POI_CARD_BID_MV = {
  CARD: 'b_waimai_kdo5j8kw_mv', // 外卖商菜卡片
  SKU: 'b_waimai_vzmho38p_mv', // 下挂菜
  COUPON: 'b_waimai_x2f4h97v_mv', // 下挂券
}

export const POI_CARD_BID_MC = {
  CARD: 'b_waimai_kdo5j8kw_mc', // 外卖商菜卡片
  SKU: 'b_waimai_vzmho38p_mc', // 下挂菜
  COUPON: 'b_waimai_x2f4h97v_mc', // 下挂券
}

export const PRODUCT_CARD_BID_MV = {
  CARD: 'b_waimai_ayyh73rl_mv', // 团购商卡
}

export const PRODUCT_CARD_BID_MC = {
  CARD: 'b_waimai_ayyh73rl_mc', // 团购商卡
}

export const LX_CONFIG = {
  NAVIGATION_HEADER_BID_MV,
  NAVIGATION_HEADER_BID_MC,
  RESOURCE_SLOT_BID_MV,
  RESOURCE_SLOT_BID_MC,
  TABBAR_BID_MV,
  TABBAR_BID_MC,
  POI_CARD_BID_MV,
  POI_CARD_BID_MC,
  PRODUCT_CARD_BID_MV,
  PRODUCT_CARD_BID_MC,
}
